<template>
  <div class="login">
    <div class="login-box">
      <div class="title">广西公路学会</div>
      <div class="logo">
        <img src="@/assets/logo.png" alt="" />
      </div>
      <el-form>
        <el-form-item label=" ">
          <el-input v-model="userName" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-input
            v-model="password"
            placeholder="请输入密码"
            type="password"
            @keyup.enter.native="login"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div class="reset-password" @click="dialogVisible = true">忘记密码</div>
      <div class="btns">
        <el-button type="primary" @click="login">登录</el-button>
      </div>
    </div>
    <div class="login-box-top"></div>
    <div class="login-box-bottom"></div>

    <el-dialog title="找回密码" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
      <el-form label-width="100px" :model="form">
        <el-form-item label="邮箱">
          <el-input v-model="form.email" placeholder="请输入邮箱">
            <el-button slot="append" @click="sendCode">{{
              countDown == 0 ? "发送验证码" : "(" + countDown + "秒)后重新发送"
            }}</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="验证码">
          <el-input v-model="form.passcode" placeholder="请输入验证码">
          </el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input
            v-model="form.password"
            show-password
            placeholder="请输入新密码"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="确认新密码">
          <el-input
            v-model="form.confirmPassword"
            show-password
            placeholder="请再次输入新密码"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div class="btns">
        <el-button type="primary" @click="confirm">确认</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userName: "",
      password: "",
      form: {
        email: "",
        passcode: "",
        password: "",
        confirmPassword: "",
        unitName: "",
      },
      timer: null,
      countDown: 0,
      disabledSend: false,
      dialogVisible: false,
    };
  },
  methods: {
    sendCode() {
      if (this.disabledSend) return;
      this.disabledSend = true;
      this.$https
        .get(this.$api.getForgetPasswordPasscode, {
          email: this.form.email,
        })
        .then(() => {
          this.countDown = 60;
          this.timer = setInterval(() => {
            if (this.countDown == 0) {
              clearInterval(this.timer);
              this.timer = null;
              this.disabledSend = false;
            } else {
              this.countDown -= 1;
            }
          }, 1000);
          this.$message.success("发送成功");
        })
        .catch(() => {
          clearInterval(this.timer);
          this.countDown = 0;
          this.timer = null;
          this.disabledSend = false;
        });
    },
    confirm() {
      if (!this.form.passcode) {
        this.$message.warning("请输入邮箱");
        return;
      }
      if (!this.form.passcode) {
        this.$message.warning("请输入验证码");
        return;
      }
      if (!this.form.password) {
        this.$message.warning("请输入新密码");
        return;
      }
      if (this.form.password != this.form.confirmPassword) {
        this.$message.warning("两次输入新密码不一致");
        return;
      }
      this.$https
        .post(this.$api.forgetPassword, {
          email: this.form.email,
          passcode: this.form.passcode,
          password: this.form.password,
        })
        .then((res) => {
          this.$message.success("修改密码成功");
          this.dialogVisible = false;
        });
    },
    login() {
      this.$https
        .post(this.$api.login, {
          userName: this.userName,
          password: this.password,
        })
        .then((res) => {
          const data = res;
          sessionStorage.setItem("admninUserInfo", JSON.stringify(data));
          this.$message.success("登录成功");
          this.$router.push({
            name: "dashboard",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  position: relative;
  width: 100%;
  height: 100%;

  .login-box {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
    width: 300px;
    border-radius: 8px;
    padding: 30px;
    border: 1px solid #dedede;
    z-index: 1;
    background: #fff;
    box-shadow: 0 2px 12px 0 #989898;
    .logo {
        text-align: center;
        img {
            width: 100px;
        }
    }
    .title {
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 20px;
    }

    .reset-password {
      float: right;
      font-size: 12px;
      position: relative;
      top: -10px;
      cursor: pointer;
    }

    .btns {
      text-align: center;

      .el-button {
        width: 100%;
      }
    }
  }

  .login-box-top {
    position: absolute;
    width: 100%;
    height: 50%;
    background: #499ee7;
  }

  .login-box-bottom {
    position: absolute;
    top: 50%;
    width: 100%;
    height: 50%;
    background: #eee;
  }
}

.btns {
  text-align: center;
}
</style>